import { Box, Stack } from '@mui/material'
import React from 'react'
import CaseProcedureDetailsRow from './CaseProcedureDetailsRow';
import CPTDetails from './CPTDetails';
import CPTModifierDetails from './CPTModifierDetails';

interface Props {
  caseProcedures: any[];
}

export default function CaseProceduresDetails({ caseProcedures }: Props) {

  return (
    <Box>
      {caseProcedures.map((caseProcedure, index) => {
        return (
          <Box key={caseProcedure.id}>
            <Box mt={3}>
              <CaseProcedureDetailsRow data={caseProcedure} index={index} />
            </Box>

            {caseProcedure.case_procedure_cpt.length > 0 && <Box mt={3}>
              <CPTDetails cpts={caseProcedure.case_procedure_cpt} />
            </Box>}

            {caseProcedure.cpt_modifier && <Box mt={3}>
              <CPTModifierDetails cpts={caseProcedure.case_procedure_cpt} cptModifier={caseProcedure.cpt_modifier} />
            </Box>}
          </Box>
        )
      })}
    </Box>
  )
}
